/** เครื่องจักรใต้ Work Center — `GET /v1/machines` (MASTER_DATA) */

export type MachineStatus = 'ACTIVE' | 'INACTIVE';

export interface Machine {
  readonly machine_id: string;
  readonly machine_code: string;
  readonly name: string;
  readonly plant_code: string;
  readonly work_center_code: string;
  readonly status: MachineStatus;
  /** NUMERIC เป็นสตริง; null = ยังไม่ตั้งค่า */
  readonly machine_rate_per_hour: string | null;
  readonly qr_payload: string;
}

export function parseMachine(raw: Readonly<Record<string, unknown>>): Machine | null {
  const str = (key: string): string | null => {
    const value = raw[key];
    return typeof value === 'string' ? value : null;
  };
  const id = str('machine_id');
  const code = str('machine_code');
  const name = str('name');
  const plant = str('plant_code');
  const wc = str('work_center_code');
  const status = str('status');
  const qr = str('qr_payload');
  if (
    id === null ||
    code === null ||
    name === null ||
    plant === null ||
    wc === null ||
    qr === null ||
    (status !== 'ACTIVE' && status !== 'INACTIVE')
  ) {
    return null;
  }
  const rate = raw.machine_rate_per_hour;
  return {
    machine_id: id,
    machine_code: code,
    name,
    plant_code: plant,
    work_center_code: wc,
    status,
    machine_rate_per_hour: typeof rate === 'string' ? rate : null,
    qr_payload: qr,
  };
}
